import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { KakaoService } from '../services/kakao/kakao.service'

@Injectable({
  providedIn: 'root',
})
export class KakaoCallbackGuard implements CanActivate {
  constructor(private kakaoService: KakaoService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const code = route.queryParams.code
    if (code && this.kakaoService.receivedKakaoAuthCodeList.includes(code)) {
      return false
    }
    return true
  }
}
